// @flow
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Helmet } from 'react-helmet'
import { format } from 'date-fns'
import classNames from 'classnames'
import Layout from '../layout'
import Button from '../components/button'
import Icon from '../components/icon'
import styles from './registration.module.css'

function RegistrationPage() {
  const data = useStaticQuery(graphql`
    query Registration {
      site {
        siteMetadata {
          email
          dates {
            earlyRegistrationBy
            speakerRegistrationBy
            regularRegistrationBy
          }
          links {
            registrationForm
            webshop
          }
        }
      }
    }
  `)
  const { email, dates, links } = data.site.siteMetadata
  return (
    <Layout>
      <Helmet>
        <title>Registration</title>
      </Helmet>
      <h1>Registration</h1>
      <p>Registration for the conference is organized in two steps:</p>
      <ol>
        <li>filling out the registration form</li>
        <li>
          payment of the conference fee through the University of Zadar web shop
        </li>
      </ol>
      <h2>Registration</h2>
      <p>
        When filling out the form, you should choose whether you wish to attend
        the conference dinner (included in the registration fee), city tour
        (included in the registration fee) or excursion (payable on site). After
        submitting the form you will proceed to payment, and once you complete
        the payment you will receive an e-mail confirmation.
      </p>
      <h2>Payment</h2>
      <p>
        University of Zadar web shop provides easy payment by credit card or
        bank transfer in two steps, Add to Basket and Purchase. The conference
        fee, which includes VAT and bank transfer charges, includes conference
        and workshop attendance, printed version of the program, conference
        materials, Book of abstracts, coffee/tea breaks, lunches and conference
        dinner.
      </p>
      <table style={{ width: '100%' }}>
        <thead>
          <tr>
            <th />
            <th>Regular participant</th>
            <th>Student</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              Early registration (by{' '}
              {format(dates.earlyRegistrationBy, 'D MMMM YYYY')}):
            </td>
            <td>500 kn (66 €)</td>
            <td>300 kn (40 €)</td>
          </tr>
          <tr>
            <td>
              Regular fee (by{' '}
              {format(dates.regularRegistrationBy, 'D MMMM YYYY')}):
            </td>
            <td>600 kn (80 €)</td>
            <td>400 kn (53 €)</td>
          </tr>
          <tr>
            <td>Late registration (on site):</td>
            <td>700 kn (93 €)</td>
            <td>500 kn (66 €)</td>
          </tr>
        </tbody>
      </table>
      <p className={styles.cta}>
        <Button
          as="a"
          href={links.registrationForm}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon id="pen" size={24} />
          <span>Registration form</span>
        </Button>
        <Icon
          className={classNames(styles.icon, styles.vertical)}
          id="arrow-down"
          size={24}
        />
        <Icon
          className={classNames(styles.icon, styles.horizontal)}
          id="arrow-right"
          size={24}
        />
        <Button
          as="a"
          href={links.webshop}
          target="_blank"
          rel="noopener noreferrer"
        >
          <Icon id="ticket" size={24} />
          <span>Web Shop</span>
        </Button>
      </p>
      <p>
        All accepted submissions must have at least one paid registration. The
        registration deadline for accepted abstracts is{' '}
        <strong>
          <time dateTime={format(dates.speakerRegistrationBy, 'YYYY-MM-DD')}>
            {format(dates.speakerRegistrationBy, 'D MMMM YYYY')}
          </time>
        </strong>
        . Abstracts which are not registered by deadline will be removed from
        the programme of the conference and the book of abstracts. Registration
        fees can be transferred to another co-author under special
        circumstances. All transfer requests must be sent to{' '}
        <a href={`mailto:${email}`}>{email}</a>.
      </p>
      <h2>Cancellations and Refunds</h2>
      <p>
        Requests for cancellations should be sent to pubmet@unizd.hr.
        Registrations cancelled more than 60 days before the event will be
        refunded 60 % of the registration fees. Registrations cancelled between
        60 and 30 days before the event will be refunded 30 % of the
        registration fees. <strong>No refunds</strong> will be made for
        cancellations made less than 30 days before the event.
      </p>
      <h2>Author no show</h2>
      <p>
        PUBMET2019 enforces a strict “no show” policy. Each accepted submission
        should be presented by one of the authors in person at the conference
        site according to the published schedule. Any paper accepted into the
        program, but not presented on site will be withdrawn from the official
        program and proceedings.
      </p>
    </Layout>
  )
}

export default RegistrationPage
